export const DISCLAIMER_TEXTS = {
  shortHint: {
    zh: '人工智能辅助草稿。使用前需经过律师审核和核实。',
    en: 'AI-assisted draft. Must be reviewed and verified by a qualified lawyer before use.',
  },
  fullDisclaimer: {
    zh: [
      '人工智能辅助草稿 – 重要免责声明',
      '',
      '这些材料是在人工智能的帮助下生成的，仅基于生成时在 Carabela 内选择并提供的资料。它可能包含错误、遗漏、不准确、分析不完整、格式不正确或不再最新的信息。',
      '',
      '它仅作为一个起草、组织和工作流程辅助工具提供。并非法律意见，亦不构成法律服务，亦不产生律师与当事人的关系，亦不得倚赖以取代获授权法律执业者的独立专业判断。',
      '',
      '在材料被使用、提交、发送、共享、依赖或提供给任何客户、法院、权威机构、第三方或其他收件人之前，责任律师必须独立审查、核实、修改和批准所有事实、日期、权威机构，法律主张、计算、引用、程序要求、保密问题和最终措辞。',
      '',
      'Carabela 或 4most.ai、其开发者以及任何 AI 提供商均无法保证此资料内容准确、完整、适宜、可用、安全或适合任何特定用途，亦不对因其使用、依赖、披露或分发而导致的任何损失、后果、索赔、决定、行动、疏忽或责任承担任何责任。',
      '',
      '用户仍需自行负责确保遵守所有适用的专业职责、法律义务、法院规则、保密要求、数据保护职责和公司政策。',
    ].join('\n'),
    en: [
      'AI-Assisted Draft – Important Disclaimer',
      '',
      'These materials were generated with the assistance of artificial intelligence, based solely on materials selected and provided within Carabela at the time of generation. They may contain errors, omissions, inaccuracies, incomplete analysis, improper formatting, or information that is no longer current.',
      '',
      'They are provided solely as a drafting, organisational and workflow aid. They are not legal advice, do not constitute legal services, do not create a lawyer-client relationship, and must not be relied upon in place of the independent professional judgement of an authorised legal practitioner.',
      '',
      'Before any materials are used, filed, sent, shared, relied upon, or provided to any client, court, authority, third party or other recipient, the responsible lawyer must independently review, verify, revise and approve all facts, dates, authorities, legal claims, calculations, citations, procedural requirements, confidentiality issues and final wording.',
      '',
      'Neither Carabela nor 4most.ai, its developers, nor any AI provider, makes any warranty that the content of these materials is accurate, complete, appropriate, usable, safe or fit for any particular purpose, and none shall bear any liability for any loss, consequence, claim, decision, action, omission or responsibility arising from their use, reliance, disclosure or distribution.',
      '',
      'The user remains responsible for ensuring compliance with all applicable professional duties, legal obligations, court rules, confidentiality requirements, data protection duties and firm policies.',
    ].join('\n'),
  },
  chatDisclaimer: {
    zh: '本内容由 AI 辅助生成，仅作研究参考，不构成法律意见，全部内容须经执业律师独立审核修正后使用，平台不承担任何使用衍生责任。',
    en: 'This content was generated with AI assistance for research reference only. It does not constitute legal advice. All content must be independently reviewed and corrected by a qualified practising lawyer before use. The platform bears no liability for any consequences arising from its use.',
  },
  confirmCheckbox: {
    zh: '我确认我已审阅过这份由人工智能辅助生成的材料，并将继续对它的使用负责。',
    en: 'I confirm that I have reviewed this AI-assisted material and will remain responsible for its use.',
  },
  modalTitle: {
    zh: 'AI 内容确认',
    en: 'AI Content Confirmation',
  },
  modalConfirmBtn: {
    zh: '确认并继续',
    en: 'Confirm & Continue',
  },
  modalCancelBtn: {
    zh: '取消',
    en: 'Cancel',
  },
} as const

export type DisclaimerLang = keyof typeof DISCLAIMER_TEXTS.shortHint
